import { FormField } from '../dynamic-form.types';

export function buildDefaultValues(items: FormField[]): Record<string, string> {
  const defaultValues: Record<string, string> = {};

  items.forEach((field) => {
    defaultValues[field.key] = field.defaultValue;
  });

  return defaultValues;
}
